// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Footer__Responsive$PrezzeeRibbon from "./Footer__Responsive.bs.js";

function columnHeading(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(18)),
              BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.rem(1)),
              BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(19)),
              BsCssJs$PrezzeeRibbon.color(match.footer.headingColor),
              BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(19))]),
              BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.tablet, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(24))]),
              BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(30))])
            ]);
}

var Styles = {
  columnHeading: columnHeading
};

function Footer__Heading(props) {
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: props.children,
                    className: columnHeading(theme)
                  })
            });
}

var make = Footer__Heading;

export {
  Styles ,
  make ,
}
/* react/jsx-runtime Not a pure module */
